<template>
  <div class="container">
    <ul class="nav nav-tabs nav-fill nav-tabs-sm">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{'active': activeTab === 'license-inquiry'}"
          @click="changeTabs('license-inquiry')"
        >
          {{ $t("AdminManagement.Tabs.LicenseInquiry") }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{'active': activeTab === 'license-issue'}"
          @click="changeTabs('license-issue')"
        >
          {{ $t("AdminManagement.Tabs.LicenseIssue") }}
        </a>
      </li>
    </ul>

    <div class="tab-contents">
      <div v-show="activeTab === 'license-inquiry'">
        <license-list page-type="adminSetting" />
      </div>

      <div v-show="activeTab === 'license-issue'">
        <license-issue />
      </div>
    </div>
  </div>
</template>

<script>
import LicenseIssue from './components/LicenseIssue.vue'
import LicenseList from './components/LicenseList.vue'
import { mapState, mapActions } from 'vuex'

export default {
  title: 'AbejaAdmin',
  components: {
    LicenseIssue,
    LicenseList
  },
  data: () => ({
    activeTab: 'license-inquiry'
  }),
  computed: {
    ...mapState('auth', [
      'uid',
    ]),
    ...mapState('auth', [
      'userSettingData'
    ]),
  },
  mounted() {
    this.setLoadingState('loadAdminSettingData')
    Promise.all([
      this.loadAdminLicenseData(this.uid),
      this.initAdminCustomerSetting()
    ]).finally(() => {
      this.unsetLoadingState('loadAdminSettingData')
    })
  },
  methods: {
    ...mapActions([
      'setLoadingState',
      'unsetLoadingState'
    ]),
    ...mapActions('auth', [
      'loadAdminLicenseData',
      'initAdminCustomerSetting'
    ]),
    changeTabs(target) {
      this.activeTab = target
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
